<template>
  <div class="container">
    <chat-form-component
      @messagesent="addMessage"
      :user="user"
    ></chat-form-component>

    <div v-for="user in users">
      {{ user }}
    </div>

    <div v-for="message in messages">
      {{ message.message }}
    </div>

  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      user: {
        id: 1,
        name: 'name',
      },
      users: [],
      messages: [],
    };
  },
  methods: {
    addMessage(message) {
      axios.post('/ajax/panel/message/add', message).then(response => {
      });
    }
  },
  mounted() {
    Echo.join('chat.1')
      .here(users => {
        this.users = users;
      })
      .joining(user => {
        this.users.push(user);
      })
      .leaving(user => {
        this.users = this.users.filter(u => u.id !== user.id);
      })
      .listenForWhisper('typing', ({ id, name }) => {
        this.users.forEach((user, index) => {
          if (user.id === id) {
            user.typing = true;
            this.$set(this.users, index, user);
          }
        });
      })
      .listen('NewMessage', (event) => {
        this.messages.push({
          message: event.message,
        });

        this.users.forEach((user, index) => {
          if (user.id === event.user.id) {
            user.typing = false;
            this.$set(this.users, index, user);
          }
        });
      });
  }
};
</script>
